import httpClient from './httpClient'

const END_POINT = '/seller'

const SellerOfferApi = {
  async getAllSellerOffers(accountId) {
    const url = `${END_POINT}/${accountId}/offers`
    return await httpClient.get(url)
  },
  async getSellerOfferRegistrations(accountId) {
    const url = `${END_POINT}/${accountId}/offers/applied`
    return await httpClient.get(url)
  },
  async getSellerOfferDetailsById(accountId, id) {
    const url = `${END_POINT}/${accountId}/offers/${id}`
    return await httpClient.get(url)
  },
  async submitParticipationRequest(accountId, payload) {    
    const url = `${END_POINT}/${accountId}/offers/submit-request`
    return await httpClient.post(url, payload)
  },
  async withdrawParticipationRequest(accountId, id) {
    const url = `${END_POINT}/${accountId}/offers/${id}/withdraw-request`
    return await httpClient.post(url, {})
  },
  async getSellerOfferBiddingURL(accountId, registrationId) {
    const url = `${END_POINT}/${accountId}/offers/${registrationId}/urls`
    return await httpClient.get(url)
  },
  async updateCreativeFiles(accountId, registrationId, payload) {
    const url = `${END_POINT}/${accountId}/offers/${registrationId}/creative-files`
    return await httpClient.patch(url, payload)
  }
}

export default SellerOfferApi
